import { render, staticRenderFns } from "./ExLocalAuthority.vue?vue&type=template&id=c847c446"
import script from "./ExLocalAuthority.vue?vue&type=script&lang=js"
export * from "./ExLocalAuthority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports